import getFatigue from "./getFatigue";
//--------------
// calc sr adjs
//--------------
export default function calcSRAdjs(p) {
  // console.log("----------------------");
  // console.log("calcSRAdjs");
  //----------
  // set vars
  //----------
  let baseline_sr_adj = 0;
  let new_sr_adj = 0;
  //-----------------------------------
  // get existing fatigue adj (if any)
  //-----------------------------------
  let existing_fatigue_obj = getFatigue(p.existing_fatigue_str);
  let existing_fatigue_sr_adj = existing_fatigue_obj.sr_adj;
  // console.log("existing_fatigue_sr_adj = " + existing_fatigue_sr_adj);
  // console.log("-------------------------------");
  //===========================================
  // A. FATIGUE CHANGE
  //===========================================
  if (Object.hasOwn(p, "new_fatigue_obj")) {
    // console.log("got new fatigue");
    //---------------------------------------------------
    // where existing fatigue adj not zero - reverse adj
    //---------------------------------------------------
    if (existing_fatigue_sr_adj != 0) {
      // console.log("existing sr adj exists");
      new_sr_adj = p.existing_sr_adj - existing_fatigue_sr_adj;
      // console.log("backed-out sr adj = " + new_sr_adj);
      // console.log("-------------------------------");
    }
    //--------------------------------------
    // calc baseline sr_adj w/o fatigue adj
    //--------------------------------------
    baseline_sr_adj = p.existing_sr_adj - existing_fatigue_sr_adj;
    // console.log("baseline = " + baseline_sr_adj);
    //---------------------
    // get new fatigue adj
    //---------------------
    let new_fatigue_sr_adj = p.new_fatigue_obj.sr_adj;
    // console.log("new_fatigue_sr_adj = " + new_fatigue_sr_adj);
    //--------------------------------
    // where new fatigue adj not zero
    //--------------------------------
    if (new_fatigue_sr_adj != 0) {
      // console.log("sr_adj present");
      //----------------------------------
      // calc sr adj (baseline + new adj)
      //----------------------------------
      new_sr_adj = baseline_sr_adj + new_fatigue_sr_adj;
      // console.log("new sr_adj = " + new_sr_adj);
      //---------------------------------------
      // where new fatigue adj = 0 -> baseline
      //---------------------------------------
    } else {
      // console.log("no sr adjs - use existing");
      new_sr_adj = baseline_sr_adj;
    }
  }
  //===========================================
  // B. SURPRISE CHANGE
  //===========================================
  if (Object.hasOwn(p, "new_surprised")) {
    // console.log("got surprise = " + p.new_surprised);
    //-----------
    // surprised
    //-----------
    if (p.new_surprised == true) {
      // console.log("A current new_sr_adj = " + new_sr_adj);
      // console.log("A existing_sr_adj = " + p.existing_sr_adj);
      new_sr_adj = p.existing_sr_adj - 10;
      // console.log("A new new_sr_adj = " + new_sr_adj);
      //---------------
      // not surprised
      //---------------
    } else {
      new_sr_adj = p.existing_sr_adj + 10;
    }
    //-------------------------
    // where existing surprise
    //-------------------------
  } else if (p.existing_surprised == true) {
    new_sr_adj = new_sr_adj - 10;
  }
  // console.log("-------------------------------");
  return new_sr_adj;
}
